import { TradeType } from 'data/Trades/types'
import fetchApi from 'utils/fetchApi'
import { getApiUrl } from 'utils/urlBuilder'

export const getRecent = (instrument: number) =>
  fetchApi<TradeType[]>({
    method: 'GET',
    url: getApiUrl(`mercury-gateway/v1/trades/${instrument}`)
  })
